require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-oud-reimerswaal.json") })
        }
      }, "path---projecten-oud-reimerswaal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-oud-reimerswaal!./.cache/json/projecten-oud-reimerswaal.json
// module id = 435
// module chunks = 231608221292675